import { createSelector } from "reselect";
import { ReportFile } from "./constants";

const report_files = (state: any) => state.report.files;

export const report_files_display = createSelector(
  report_files,
  (report_files) => {
    return report_files.map((report_file: ReportFile) => {
      return {
        ...report_file,
        status_display: report_file.status.replace(/_/, " ")
      };
    });
  }
);



// WEBPACK FOOTER //
// ./client/modules/Report/selectors.ts